<template>
  <div class="top-top-class" :class="{ 'tap-top': tapTop }" @click="scrollToTop()">
    <div>
      <img src="/images/svg/global/top-arrow.svg" class="img-fluid" alt="top" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TapTop',
  data() {
    return {
      tapTop: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(event) {
      var element = document.querySelector('#footer-color')
      var position = element.getBoundingClientRect()
      var footerPosition=position.top+300
      if ( footerPosition <= window.innerHeight) {
        this.tapTop = true
      } else {
        this.tapTop = false
      }
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.top-top-class{
  height: 0;
  &.tap-top {
  display: block;
  width: $px64 !important;
  height: $px64;
  background-color: $secondary-color;
  border-radius: 100%;
  position: fixed;
  bottom: 35%;
  right: 10%;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 2;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
  }
}
}
@media (max-width: 1540px) {
  .tap-top {
     right: 5%;
    transform: scale(0.6);
  }
}
@media (max-width: 1199px) {
  .tap-top {
     right: 5%;
    transform: scale(0.6);
  }
}
@media (max-width: 767px) {
  .tap-top {
    right: 2%;
    transform: scale(0.4);
    bottom: 28%;
  }
}
@media (max-width: 575px) {
  .tap-top {
    display: none !important;
  }
}
</style>
